import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'unidade-medida');

const unidadeMedidaActions = {
  ...genericActions(basePath),
};

export default resource => resource(`${basePath}`, {}, unidadeMedidaActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/unidade-medida.js